var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.058 1.667H2.942a1.208 1.208 0 0 0-1.225 1.191v14.284a1.209 1.209 0 0 0 1.225 1.191h14.116a1.209 1.209 0 0 0 1.226-1.191V2.858a1.208 1.208 0 0 0-1.226-1.191zM6.742 15.617h-2.5v-7.5h2.5v7.5zm-1.25-8.55a1.3 1.3 0 1 1 0-2.6 1.308 1.308 0 1 1 0 2.6zm10.267 8.55h-2.5v-4.025c0-1.009-.359-1.667-1.267-1.667a1.375 1.375 0 0 0-1.284.908 1.668 1.668 0 0 0-.083.609v4.166h-2.5v-7.5h2.5v1.059a2.5 2.5 0 0 1 2.258-1.25c1.667 0 2.876 1.075 2.876 3.383v4.317z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.28e323e2a8e159577c59d6d0519d760d.svg";
export { ForwardRef as ReactComponent };